export default __webpack_public_path__ + "static/media/640_portfolio03-jp-web.33916a10.png";